import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.array.splice";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { cloneDeep } from 'lodash';
import checkCity from './checkCity.vue';
import utilCity from '@/libs/city.json';
var specialAreasObj = {
  provinces: [],
  baseCount: undefined,
  basePrice: undefined,
  incrementCount: undefined,
  incrementPrice: undefined
};
var utilCityData = utilCity.map(function (v) {
  v.children.forEach(function (k) {
    return delete k.children;
  });
  return v;
});
export default {
  meta: {
    title: '添加模板',
    auth: true,
    authorityValue: "store-delivery-temp"
  },
  name: 'addTransportModule',
  components: {
    checkCity: checkCity
  },
  data: function data() {
    return {
      formData: {
        deliveryFeeName: '',
        freed: false,
        feeType: '',
        baseCount: undefined,
        basePrice: undefined,
        incrementCount: undefined,
        incrementPrice: undefined,
        province: '',
        specialAreas: [cloneDeep(specialAreasObj)]
      },
      layer: {
        show: false,
        title: '地区选择',
        showButton: true,
        index: 0
      }
    };
  },
  computed: {
    isMoney: function isMoney() {
      return this.formData.feeType == 1 ? '件' : 'kg';
    },
    isRadio: function isRadio() {
      return this.formData.feeType == 1;
    },
    isFreed: function isFreed() {
      return this.formData.freed;
    },
    isRules: function isRules() {
      var rules = {
        deliveryFeeName: [{
          required: true,
          message: '请输入模板名称',
          trigger: 'blur'
        }],
        freed: [{
          required: true,
          message: '是否包邮',
          trigger: 'blur'
        }]
      };
      var copyRules = {
        feeType: [{
          required: true,
          message: '请选择计费方式',
          trigger: 'blur'
        }],
        baseCount: [{
          required: true,
          message: '请输入数量',
          trigger: 'blur'
        }],
        basePrice: [{
          required: true,
          message: '请输入费用',
          trigger: 'blur'
        }],
        incrementCount: [{
          required: true,
          message: '请输入增加数量',
          trigger: 'blur'
        }],
        incrementPrice: [{
          required: true,
          message: '请输入增加费用',
          trigger: 'blur'
        }],
        specialAreas: [{
          required: true,
          message: '请输入地区计费列表',
          trigger: 'blur'
        }]
      };
      return this.isFreed ? rules : Object.assign(rules, copyRules);
    }
  },
  created: function created() {
    var query = this.$route.query;

    if (!!query) {
      this.deliveryFeeDetails(query);
    }
  },
  filters: {
    provincesName: function provincesName(e) {
      var str = [];
      e.forEach(function (v) {
        var item = utilCityData.find(function (s) {
          return s.value == v.province;
        });
        str.push(item.label);

        if (v.cities && v.cities.length > 0 && !v.allCity) {
          v.cities.forEach(function (k) {
            return str.push(item.children.find(function (s) {
              return s.value == k;
            }).label);
          });
        }
      });
      return str.join(',');
    }
  },
  methods: {
    confirmCheckCity: function confirmCheckCity(data) {
      var item = this.formData.specialAreas[this.layer.index];
      this.$set(item, 'provinces', []);
      data.forEach(function (l, i) {
        var params = {
          province: l.value,
          cities: l.children.map(function (v) {
            return v.value;
          }),
          allCity: l.allCity
        };
        item.provinces.push(params);
      });
      this.layer.show = false;
    },
    clickLayer: function clickLayer(row, index) {
      this.layer.index = index;
      this.layer.show = true;
      var keys = [];
      row.provinces.forEach(function (v) {
        v.allCity && keys.push(v.province);
        keys = keys.concat(v.cities);
      });
      this.$refs["checkCity"].getRefTree(keys);
    },
    deliveryFeeDetails: function deliveryFeeDetails(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.deliveryFeeDetails(data);

              case 2:
                res = _context.sent;
                _this.formData = Object.assign(_this.formData, res);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onSubmit: function onSubmit(item) {
      var _this2 = this;

      var slock = this.formData.specialAreas.some(function (v) {
        return v.provinces.some(function (k) {
          return !!k.province;
        });
      });
      if (!slock && !this.formData.freed) return this.$message.error('请选择地区');
      this.$refs.formData.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var showTrue;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 9;
                    break;
                  }

                  showTrue = false;

                  _this2.formData.specialAreas.forEach(function (v) {
                    var params = JSON.stringify(v);
                    if (v.provinces.length > 0 && (params.indexOf('baseCount') == -1 || params.indexOf('basePrice') == -1 || params.indexOf('incrementPrice') == -1 || params.indexOf('incrementCount') == -1)) return showTrue = true;
                  });

                  if (!showTrue) {
                    _context2.next = 5;
                    break;
                  }

                  return _context2.abrupt("return", _this2.$message.error('请填写完整信息'));

                case 5:
                  _context2.next = 7;
                  return _this2.$api.saveDeliveryFee(_this2.formData);

                case 7:
                  _this2.$notify.success({
                    title: '成功',
                    message: '添加成功'
                  });

                  _this2.goBack();

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    clickDel: function clickDel(index) {
      if (this.formData.specialAreas.length == 1) return;
      this.formData.specialAreas.splice(index, 1);
    },
    clickAdd: function clickAdd() {
      this.formData.specialAreas.push(cloneDeep(specialAreasObj));
    },
    isNumber: function isNumber(e) {
      console.log(e);
    }
  }
};